import React from 'react';
import { useFeatureNav } from '../../hooks/useFeatureNav';
import { Sparkles } from 'lucide-react';
import MyReadinessTab from './MyReadinessTab';

// "My Readiness" — every enrolled person's private growth view (R1): the
// 5-dimension readiness graph (literacy, tool adoption, usage depth, workflow,
// output impact) with stage + history. Staging's split is the standard
// (Usama, 2026-08-25): the role-based HOME lives on /dashboard (RoleDashboard);
// this page is always the personal readiness detail, never the home.
const MyReadinessPage: React.FC = () => {
  const { go } = useFeatureNav();
  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles size={22} className="text-brand-500" />
        <h1 className="text-2xl font-semibold text-gray-900">My Readiness</h1>
      </div>
      <p className="text-sm text-gray-500 mb-6">Your growth with AI — private, never a leaderboard.</p>
      <MyReadinessTab onStartOnboarding={() => go('/onboarding')} />
    </div>
  );
};

export default MyReadinessPage;
